import {Component, OnDestroy, OnInit} from '@angular/core';
import {CustomerProfileService} from '../../../services/customer-profile.service';
import {CustomerProfile} from '../../../domain/customer/customer-profile';
import {CommonComponent} from '../../shared/common/common.component';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
// import {DialogService} from 'primeng-lts/dynamicdialog';
import {DialogService} from 'primeng/dynamicdialog';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AccountService} from '../../../services/account.service';

import * as moment from 'moment';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
class Month {
  name: string;
  startDate: any;
  endDate: any;
}
interface ReferralReportResponse {
  reportItems: {
    levelOfHierarchy: number;
  }[];
}

@Component({
  selector: 'app-my-referrals',
  templateUrl: './my-referrals.component.html',
  styleUrls: ['./my-referrals.component.scss']
})
export class MyReferralsComponent extends CommonComponent implements OnInit, OnDestroy {
  referralsReport;
  months: Month[];
  profileDetail: CustomerProfile;
  profileLanguage: string;
  selectedValue: Month;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  constructor(
    private customerProfileService: CustomerProfileService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private accountsService: AccountService,
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.onReferralReportSelection(this.selectedValue);
    });
  }
  ngOnInit(): void {
    this.getMonths();
  }
  // Get months
  getMonths(){
    this.loadingModalOn();
    this.months = [];
    this.customerProfileService.customerProfile$.pipe(takeUntil(this.destroyed$)).subscribe(
      (response: any) => {
        this.profileDetail = response;
        this.profileLanguage = this.profileDetail.language;
        // Get Current month
        const currentStartDate = moment().startOf('month').format('YYYY-MM-DD');
        const currentDate = moment().format('YYYY-MM-DD');
        // Get 1 month before
        const oneMonthAgo = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        const endOfOneMonthAgo = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
        // Get 2 months before
        const twoMonthsAgo = moment().subtract(2, 'months').startOf('month').format('YYYY-MM-DD');
        const endOfTwoMonthsAgo = moment().subtract(2, 'months').endOf('month').format('YYYY-MM-DD');
        // Initialization of Array of objects of type Month.
        const currentMonthName = moment().locale(this.profileLanguage).format('MMMM');
        const firstOptionMonth = {name: currentMonthName , startDate: currentStartDate, endDate: currentDate};
        this.selectedValue = firstOptionMonth;
        this.months.push(firstOptionMonth);
        const pastMonthName = moment().locale(this.profileLanguage).subtract(1, 'months').startOf('month').format('MMMM');
        this.months.push({name: pastMonthName , startDate: oneMonthAgo, endDate: endOfOneMonthAgo});
        const twoMonthsAgoName = moment().locale(this.profileLanguage).subtract(2, 'months').startOf('month').format('MMMM');
        this.months.push({name: twoMonthsAgoName, startDate: twoMonthsAgo, endDate: endOfTwoMonthsAgo});
        if (this.profileLanguage === 'es'){
          this.months.push({name: '3 Meses', startDate: twoMonthsAgo, endDate: currentDate});
        } else {
          this.months.push({name: '3 Months', startDate: twoMonthsAgo, endDate: currentDate});
        }
        this.loadingModalOff();
      }, error => {
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }
  onReferralReportSelection(selectedOption: Month) {
    this.loadingModalOn();
    const startDate = selectedOption.startDate;
    const endDate = selectedOption.endDate;
    this.accountsService.getMyReferralsReport(startDate, endDate).subscribe(
      (response: ReferralReportResponse) => {
        const levelNames = {
          1: this.translate.instant('referrals.levelNames.closestFriends'),
          2: this.translate.instant('referrals.levelNames.closeFriends'),
          3: this.translate.instant('referrals.levelNames.friends')
        };
        response?.reportItems.forEach(item => {
          item.levelOfHierarchy = levelNames[item.levelOfHierarchy];
        });
        this.referralsReport = response;
        this.loadingModalOff();
      }, error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.unsubscribe();
  }
}
